/**
 * Coach settings (scheduling, notifications, etc.).
 * GET /actions/coach-settings — returns saved settings JSON or 404.
 * PUT /actions/coach-settings — body is the full settings object to save (JSON).
 * GET /actions/coach-settings/membership-plans — returns press plans [{id, label}] for the gym.
 * Does not redirect so the client can stay on the page.
 */
const CoachSettings = (app) => {
    app.get("/coach-settings", async ({ res, api }) => {
      try {
        const response = await api("coach-settings");
        if (!response.ok) {
          res.status = response.status;
          res.body = response.status === 404 ? null : await response.text();
          return;
        }
        const body = await response.json();
        // Normalize: API may return the doc in a wrapper or as an array
        const doc =
          Array.isArray(body) && body.length > 0
            ? body[0]
            : body && typeof body === "object" && body.data != null
              ? body.data
              : body && typeof body === "object" && body.result != null
                ? body.result
                : body;
  
        res.headers = res.headers || {};
        res.headers["Content-Type"] = "application/json; charset=utf-8";
        if (res.status == null) res.status = 200;
        res.body = JSON.stringify(doc);
      } catch (e) {
        res.status = 500;
        res.body = JSON.stringify({
          error: e.message || "Failed to load settings",
        });
      }
    });
  
    app.get("/coach-settings/membership-plans", async ({ res, api, locals }) => {
      try {
        const query = locals.activeUser?.organizationId
          ? { organizationUser: locals.activeUserToRequest._id }
          : {};
        const response = await api("coach-plan-manager", { query });
        if (!response.ok) {
          res.status = response.status;
          res.body = null;
          return;
        }
        const data = await response.json();
        const pressPlans = Array.isArray(data?.pressPlans) ? data.pressPlans : [];
        res.headers = res.headers || {};
        res.headers["Content-Type"] = "application/json; charset=utf-8";
        res.status = 200;
        res.body = JSON.stringify(
          pressPlans.map(({ id, nickname }) => ({ id, label: nickname ?? id }))
        );
      } catch (e) {
        res.status = 500;
        res.body = JSON.stringify({ error: e.message || "Failed to load plans" });
      }
    });

    app.put("/coach-settings", async ({ req, res, api }) => {
      let body = req.body;
      if (typeof body === "string") {
        try {
          body = JSON.parse(body);
        } catch {
          body = {};
        }
      }
      body = body || {};
      try {
        await api("coach-settings", {
          method: "PUT",
          body,
        });
        res.status = 204;
        res.body = null;
      } catch (e) {
        res.status = 500;
        res.body = JSON.stringify({
          error: e.message || "Failed to save settings",
        });
      }
    });
  };
  
  export default CoachSettings;